import { ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { GameRewards } from 'src/AngularJS/Goals/Gamification/Models/game-history';
import { GameActionObject, IntervalType } from 'src/app/dashboard/modules/cxone-games/game.models';
import { GameType } from 'src/app/gamification/command-center/models/games.model';
import { Budget } from 'src/app/gamification/cv-admin/models/budget.model';
import { BudgetService } from 'src/app/gamification/cv-admin/services/budget/budget.service';
import { GenericMetricFormatterPipe } from 'src/app/reusables/pipes/generic-metric-formatter.pipe';
import { IHGameStandardize, IHSelectedMetric, ParticipantObj, NumericType, TimeType, GameTopPerformer, HistoricalTeamObj } from '../../../models/games-parameter.model';
import { GamesParameterHistoryService } from '../../../services/games-parameter-history.service';
import { GamesService } from '../../../services/games.service';
import { GamificationMainService } from '../../../services/gamification-main.service';
import { Game, Qualifier, Interval, MetricAverage } from './selected-game.model';
import { GameHistoryBreakdownEffectivenessComponent } from '../games-history-health-components/game-history-breakdown-effectiveness/game-history-breakdown-effectiveness.component';
import { DatePipe } from '@angular/common';
import { HealthReportTopPerformersComponent } from '../games-history-health-components/health-report-top-performers/health-report-top-performers.component';
import { isConnect3, isConnectAll } from '../../../models/games-player-breakdown';

const MAX_RECENT_DAYS = 30; // Max number of days in which a game is considered recent
interface GroupedData {
    count: number;
    hasTargetDate: boolean;
    hasValidActionType: boolean;
    hasCollected: boolean;
}

@Component({
    selector: 'cv-games-history-health-report',
    templateUrl: './games-history-health-report.component.html',
    styleUrls: ['./games-history-health-report.component.scss']
})

export class GamesHistoryHealthReportComponent implements OnInit, OnChanges {
    @ViewChild(GameHistoryBreakdownEffectivenessComponent) GameEffectiveness!: GameHistoryBreakdownEffectivenessComponent;
    @ViewChild(HealthReportTopPerformersComponent) TopPerformers!: HealthReportTopPerformersComponent;
    @ViewChild('Rewards_Collected', { static: false }) rewards_collected: ElementRef;
    @ViewChild('Collect_Button', { static: false }) collect_button: ElementRef;
    HealthReportTopPerformersComponent
    @Input() intervalSelected: Interval[];
    @Input() selectedGame: Game | null = null;
    @Input() endDate: string = null;
    @Input() participants: ParticipantObj[];
    @Input() teamsInfo: { [key: number]: HistoricalTeamObj } = {};
    @Input() gameRewards: GameRewards[] = null;
    @Input() gameActions!: GameActionObject;
    private cache: Map<string, any> = new Map();
    private averageValuesCache = new Map<string, { previous: any[]; current: any[] }>();

    _loadingGameParams = true;
    GameTypeEnum = GameType;
    historyGame: IHGameStandardize = null
    gs = null;
    isLoading: boolean = true;
    qualifierType: string = "";
    qualifierLeft: string;
    qualifierRight: string;
    previousQualifier: Qualifier;
    sumCoins: number = 0;
    sumPlayers: number = 0;
    sumXP: number = 0;
    sumBadges: number = 0;
    sumCustomRewards: number = 0;
    budgetPercentage: number = 0;
    joinedCount: number = 0;
    firstAverageMetricValue: number = null;
    budget: Budget = {
        budgetList: [],
        totalAmount: null,
        initBudgetList: []
    };
    collectedCount;
    collectedPercentage: number;
    metricList: IHSelectedMetric[] = [];
    gameMetric: IHSelectedMetric;
    qualifier: IHSelectedMetric;
    component: { Qualifier: { conversionType: string; }; }[];
    groupedParticipantRewards: Record<string, GroupedData> = {};
    countParticipantRewards: number = 0;
    exportData = null;
    gameEffectiveness: any[];
    metricResults: any;
    metricAverageResults = null;
    topPerformers: GameTopPerformer[];
    previousMetricResults = null;
    currentMetricResults = null;
    allMetrics = [];

    constructor(
        private metricFormatter: GenericMetricFormatterPipe,
        private formattedMetricPipe: GenericMetricFormatterPipe,
        private cdRef: ChangeDetectorRef,
        private gamesParameterHistoryService: GamesParameterHistoryService,
        private gamesService: GamesService,
        private budgetService: BudgetService,
        private gamificationService: GamificationMainService,
        private datePipe: DatePipe,
    ) {
        this.gs = this.gamesService.data;
    }

    ngOnInit(): void {
        this.loadBudgetandCollectButtonSettings();
    }

    async ngOnChanges(changes: SimpleChanges): Promise<void> {
        if (changes.endDate?.currentValue || changes.selectedGame?.currentValue && changes.selectedGame.currentValue.RuleID) {
            this.selectedGame = changes.selectedGame?.currentValue || this.selectedGame;
            this.endDate = changes.endDate?.currentValue?.split('T')[0] || this.endDate;
            this.gameActions = changes.gameActions?.currentValue || this.gameActions;
            if (this.selectedGame.RuleID > 0 && this.endDate) {
                this._loadingGameParams = true;
                this.gamesParameterHistoryService.loadGameHistoryParams(this.selectedGame.RuleID, this.endDate).then((game) => {
                    this.historyGame = game;
                }).finally(() => {
                    this._loadingGameParams = false;
                    this.firstAverageMetricValue = null;
                    this.getMetrics();
                });
            }
        }

        if (changes.participants && changes.participants.currentValue) {
            this.participants = changes.participants?.currentValue;
            this.sumPlayers = this.participants.reduce((sum, current) => sum + 1, 0);
            this.sumCoins = this.participants.filter((a: any) => { return a.calculatedCoins >= 0; }).reduce((sum, current) => sum + current.calculatedCoins, 0);
            this.sumXP = this.participants.filter((a: any) => { return a.calculatedXP >= 0; }).reduce((sum, current) => sum + current.calculatedXP, 0);
            this.sumBadges = this.participants.reduce((sum, current) => sum + current.badges.length, 0);
            this.sumCustomRewards = this.participants.filter((a: ParticipantObj) => a.custom?.length > 0 && !a.isReverted).length;
            this.joinedCount = this.participants
                .flatMap(p => p.participant)
                .filter((p: any) => p.AlreadyJoined === true)
                .length;
        }

        if (changes.teamsInfo && changes.teamsInfo.currentValue) {
            this.teamsInfo = changes.teamsInfo.currentValue;
        }

        this.isLoading = true;
        // Wait until this.participants and this.historyGame exist.
        while (!this.participants || !this.historyGame || !this.GameEffectiveness) {
            await new Promise(resolve => setTimeout(resolve, 100));
        }

        await this.CalculateAverageInterval();

        const previousAverageMap = new Map(
            this.previousMetricResults.map(metric => [
                metric.MetricName,
                {
                    averageValue: metric.averageValue,
                    formattedAverageValue: metric.formattedAverageValue
                }
            ])
        );

        const currentAverageMap = new Map(
            this.currentMetricResults.map(metric => [
                metric.MetricName,
                {
                    averageValue: metric.averageValue,
                    formattedAverageValue: metric.formattedAverageValue
                }
            ])
        );

        if (Array.isArray(this.metricList)) {
            this.metricList = this.metricList.map(item => {
                const previousMetric = (previousAverageMap.get(item.MetricDetail.Abbrev) || {}) as Partial<MetricAverage>;
                const currentMetric = (currentAverageMap.get(item.MetricDetail.Abbrev) || {}) as Partial<MetricAverage>;

                return {
                    ...item,
                    FormattedPreviousAverage: this.getFormattedData(previousMetric.averageValue, item.MetricDetail.ConversionType),
                    FormattedCurrentAverage: this.getFormattedData(currentMetric.averageValue, item.MetricDetail.ConversionType),
                    PreviousAverage: previousMetric.averageValue ?? 0,
                    CurrentAverage: currentMetric.averageValue ?? 0
                };
            });

            this.allMetrics = [...this.metricList];
        }

        if (this.gameMetric && typeof this.gameMetric === "object") {
            const previousMetric = (previousAverageMap?.get(this.gameMetric.MetricDetail.Abbrev) || {}) as Partial<MetricAverage>;
            const currentMetric = (currentAverageMap?.get(this.gameMetric.MetricDetail.Abbrev) || {}) as Partial<MetricAverage>;

            this.gameMetric = {
                ...this.gameMetric,
                FormattedPreviousAverage: this.getFormattedData(previousMetric.averageValue, this.gameMetric.MetricDetail.ConversionType),
                FormattedCurrentAverage: this.getFormattedData(currentMetric.averageValue, this.gameMetric.MetricDetail.ConversionType),
                PreviousAverage: previousMetric.averageValue ?? 0,
                CurrentAverage: currentMetric.averageValue ?? 0
            };

            this.allMetrics.push(this.gameMetric);
        }

        if (this.qualifier && typeof this.qualifier === "object") {
            const previousMetric = (previousAverageMap?.get(this.qualifier.MetricDetail.Abbrev) || {}) as Partial<MetricAverage>;
            const currentMetric = (currentAverageMap?.get(this.qualifier.MetricDetail.Abbrev) || {}) as Partial<MetricAverage>;

            this.qualifier = {
                ...this.qualifier,
                FormattedPreviousAverage: this.getFormattedData(previousMetric.averageValue, this.qualifier.MetricDetail.ConversionType),
                FormattedCurrentAverage: this.getFormattedData(currentMetric.averageValue, this.qualifier.MetricDetail.ConversionType),
                PreviousAverage: previousMetric.averageValue ?? 0,
                CurrentAverage: currentMetric.averageValue ?? 0
            };

            this.allMetrics.push(this.qualifier);
        }

        this.isLoading = false;

        if (changes.gameRewards && changes.gameRewards.currentValue) {
            const gameRewards = changes.gameRewards.currentValue;

            // Getting the target date (one day before EndDate)
            const endDate = new Date(this.intervalSelected[0]?.EndDate);
            endDate.setDate(endDate.getDate() - 1);
            const targetDate = endDate.toISOString().split("T")[0];

            this.groupedParticipantRewards = gameRewards.reduce((acc, reward) => {
                const login = reward.LoginName;
                if (!acc[login]) {
                    acc[login] = { count: 0, hasTargetDate: false, hasValidActionType: false, hasCollected: false };
                }

                // Only count if ActionType is not 10 (10= custom Reward)
                if (reward.ActionType !== 10) {
                    acc[login].count++;
                    acc[login].hasValidActionType = true;
                }

                // Check if the reward was collected
                if (reward.Collected) {
                    acc[login].hasCollected = true;
                }

                // Extract only the YYYY-MM-DD part of the ActionDate
                const actionDate = reward.ActionDate.split("T")[0];
                if (actionDate === targetDate) {
                    acc[login].hasTargetDate = true;
                }

                return acc;
            }, {} as Record<string, GroupedData & { hasValidActionType: boolean; hasCollected: boolean }>);

            this.groupedParticipantRewards = Object.fromEntries(
                Object.entries(this.groupedParticipantRewards).filter(([_, data]) => data.hasValidActionType)
            );

            // number of participants who received a prize
            this.countParticipantRewards = Object.keys(this.groupedParticipantRewards).length;

            //number of participants who collected the prize
            this.collectedCount = Object.entries(this.groupedParticipantRewards)
                .filter(([_, data]) => data.hasCollected)
                .length;
        }


        this.cdRef.detectChanges();
    }

    get timeSinceLastUpdate() {
        if (!this.selectedGame || !this.endDate) return '';
        return this.gamesParameterHistoryService.getTimeSinceLastUpdate(this.selectedGame.RuleID, this.endDate);
    }

    get isRecentlyAdded() {
        if (!this.selectedGame || !this.endDate) return '';
        return this.gamesParameterHistoryService.isRecentlyAdded(this.selectedGame.RuleID, this.endDate, MAX_RECENT_DAYS);
    }

    get participantsPercentage() {
        if (this.joinedCount === 0 || this.sumPlayers === 0) return 0;
        const percentage = parseFloat(((this.joinedCount / this.sumPlayers) * 100).toFixed(2));

        if (percentage % 1 === 0) {
            return parseInt(percentage.toFixed(0));
        }

        return percentage;
    }

    get collectedRewardsPercentage() {
        if (this.collectedCount === 0 || this.countParticipantRewards === 0) return 0;
        const percentage = parseFloat(((this.collectedCount / this.countParticipantRewards) * 100).toFixed(2));

        if (percentage % 1 === 0) {
            return parseInt(percentage.toFixed(0));
        }
        return percentage;
    }

    get isPercentageGreaterThan75(): boolean {
        return this.participantsPercentage >= 75;
    }

    get iscollectedPercentageGreaterThan75(): boolean {
        return this.collectedRewardsPercentage >= 75;
    }

    get isCollectButtonActive(): boolean {
        return !!this.historyGame.CollectButton;
    }

    get noRewards(): boolean {
        return this.sumBadges == 0 && this.sumBadges == 0 && this.sumXP == 0;
    }

    editGame() {
        this.gamesService.clearContext();
        this.gamesService.pushContext('landing');
        this.gamesService.pushContext('history');
        this.gamesService.pushContext('edit');
        this.gs.currentView = 0;
        this.gamesService.navigateTo({ type: 'edit', game: this.selectedGame, folder: { FolderData: { FolderID: this.gs.selectedGame[0].FolderID } } });
    }

    getMetrics() {
        const metrics = this.gamesParameterHistoryService.getMetrics(this.selectedGame.RuleID, this.endDate);

        if (this.selectedGame?.GameType == GameType.Raffle) {
            this.gameMetric = metrics.length > 0 ? metrics[0] : null;
            this.qualifier = metrics.length > 0 ? metrics[1] : null;
            this.metricList = [];
        }
        else if (this.selectedGame?.GameType != GameType.Connect3 && this.selectedGame?.GameType != GameType.Blackout) {
            this.gameMetric = metrics.length > 0 ? metrics.find(x => !x.IsQualifier) : null;
            this.qualifier = metrics.find(x => x.IsQualifier);
            this.metricList = [];
        } else {
            this.metricList = metrics.filter(x => !x.IsQualifier).sort((a, b) => a.Position - b.Position);
            this.gameMetric = this.metricList[0];
            this.qualifier = metrics.find(x => x.IsQualifier);
        }
        this.cdRef.detectChanges();
    }

    metricAvg(metricID: number, conversionType: number) {
        const firstValidParticipant = this.participants?.find(p => p.ruleObject !== null);

        if (this.endDate && (this.firstAverageMetricValue !== null || this.participants?.length === 0 || this.participants?.length > 0)) {
            this.isLoading = false;
        } else {
            if (this.endDate == null) this.isLoading = false;
            else this.isLoading = true;
        }

        if (firstValidParticipant?.ruleObject?.MyRankingObj?.MetricGroupInfos) {
            const foundMetric = firstValidParticipant.ruleObject.MyRankingObj.MetricGroupInfos
                .find(metric => metric.MetricID === metricID);

            this.firstAverageMetricValue = foundMetric ? foundMetric.AverageMetricValue : null;

            if (foundMetric === null && this.participants?.length > 0) {
                this.isLoading = false;
            }
        } else {
            if (this.participants?.length > 0) {
                this.isLoading = false;
            }
        }

        return this.gamesService.formatterMetricData(conversionType.toString(), this.firstAverageMetricValue);
    }

    getConnect3InitialPosition() {
        const metricPosition = this.metricList.find(
            (position: any) =>
                position.Position === 0
        );

        if (metricPosition) {
            return {
                direction: metricPosition.MetricDetail.DefaultMetricDirection === 0 ? '<' : '>',
                formattedData: this.getFormattedData(
                    metricPosition.LeftNumber,
                    metricPosition.MetricDetail.ConversionType
                )
            };
        }

        return null;
    }

    getFormattedData(value: any, conversionType: any): string {
        return this.metricFormatter.transform(value, conversionType.toString());
    }

    async loadBudgetandCollectButtonSettings() {
        const budgetList = await this.budgetService.loadBudgets();
        this.budget.budgetList = budgetList?.map((budget) => ({
            ...budget,
            AmountString: budget.Amount.toString(),
        })).sort((a, b) => a.GroupLevelName.localeCompare(b.GroupLevelName, undefined, { sensitivity: 'base' }));
        this.budget.initBudgetList = [...this.budget.budgetList];
        this.budget.totalAmount = this.budget.budgetList.reduce((acc, item) => acc + (item.Amount ?? 0), 0);
    }

    get percentageBudget() {
        if (!this.budget?.budgetList?.length || this.budget.totalAmount === 0 || this.sumCoins === 0) {
            return 0;
        }

        const percentage = parseFloat(((this.sumCoins / this.budget.totalAmount) * 100).toFixed(2));

        if (percentage % 1 === 0) {
            return parseInt(percentage.toFixed(0));
        }

        return percentage;
    }

    getLocalizedText(key: string, defaultText: string): string {
        return this.gamesService.getLocalizedMessage(key, defaultText);
    }

    async getAllTopPerformers() {
        let startDate = this.TopPerformers.getStartDateByEndDate(this.endDate, this.intervalSelected);
        this.topPerformers = [];

        const metricsArray = isConnect3(this.historyGame.GameType) || isConnectAll(this.historyGame.GameType) ? this.historyGame.Connect3Definition : [this.historyGame.metricDefinition];

        for (const metric of metricsArray) {
            const result = await this.gamesParameterHistoryService.getTopPerformers(
                this.selectedGame.RuleID,
                startDate,
                this.endDate,
                metric.MetricID,
                this.historyGame?.qualifierDefinition?.MetricID,
            );
            let topPerformersData = [];
            if (result !== undefined) {
                topPerformersData = result.map(item => ({
                    ...item,
                    MetricName: metric.MetricDetail?.Abbrev || '',
                    MetricID: metric.MetricID,
                }));
            }
            this.topPerformers.push(...topPerformersData);
        }
        return this.topPerformers;
    }

    async getAllGameEffectivenessData() {
        if (this.participants && this.GameEffectiveness) {
            const formattedParticipants = this.participants.map(({ participant }) => ({
                ...participant,
                GroupID: participant.RelatedGroupID
            })) || [];

            const previousStartDate = this.GameEffectiveness.getPreviousStartDate();
            const firstPreviousDate = previousStartDate[0];
            const formattedFirstPreviousDate = new Date(firstPreviousDate).toISOString().replace(/\.\d{3}Z$/, '');
            let endDate = null;

            if (this.selectedGame.IntervalType !== "Day" || this.selectedGame.GameType === this.GameTypeEnum.Brackets) {
                const originalEndDate = new Date(this.intervalSelected[0].EndDate);
                originalEndDate.setDate(originalEndDate.getDate() - 1);
                endDate = originalEndDate.toISOString().replace(/\.\d{3}Z$/, '');
            } else {
                endDate = new Date(this.intervalSelected[0].EndDate).toISOString().replace(/\.\d{3}Z$/, '')
            }

            const combinedMetrics = this.metricList.length
                ? this.metricList
                : [this.gameMetric];

            this.metricResults = await Promise.all(
                combinedMetrics.map(async (metric) => {
                    return await this.gamesService.LoadMetricRanking(
                        metric.MetricID.toString(),
                        formattedParticipants,
                        formattedFirstPreviousDate,
                        endDate,
                        true,
                        this.selectedGame.RuleID,
                    );
                })
            );

            this.gameEffectiveness = this.metricResults.flat();
            this.calculateAverage();
        }

        this.gameEffectiveness?.forEach(effectiveness => {
            if (!effectiveness?.IntervalAverages) {
                effectiveness.IntervalAverages = [
                    {
                        AverageValue: 0,
                        Date: this.intervalSelected[0].EndDate || new Date(),
                        FormattedDate: '',
                        FormattedValue: "---",
                        MetricID: -1,
                    }
                ]; // default average
            }

            effectiveness.IntervalAverages.forEach(interval => {
                const adjustedDate = new Date(interval.Date);
                adjustedDate.setMinutes(adjustedDate.getMinutes() + adjustedDate.getTimezoneOffset());
                interval.FormattedDate = this.GameEffectiveness.formatDate(adjustedDate);
            });
        });

        return this.gameEffectiveness || [];
    }

    calculateAverage() {
        this.updateMetricValueAverage();
        this.gameEffectiveness = this.metricResults.map(metric => {
            if (!metric?.IntervalAverages || metric?.IntervalAverages.length === 0) {
                return { ...metric, AverageValue: 0, PreviousAverage: 0 };
            }

            const metricDetail = this.allMetrics.find(m =>
                m?.MetricDetail?.Abbrev?.trim().toLowerCase() === metric.MetricName?.trim().toLowerCase()
            )?.MetricDetail;

            const direction = metricDetail?.DefaultMetricDirection ?? null;
            const conversionType = metricDetail?.ConversionType ?? metric.ConversionType ?? 0;
            const directionText = direction === 1 ? this.getLocalizedText("Up", "Up") : this.getLocalizedText("Down", "Down");

            const difference = metric.AverageValue - metric.PreviousAverage;
            let sign = difference >= 0 ? '+ ' : '- ';
            let formattedValue = this.getFormattedData(Math.abs(difference), conversionType);
            let formattedTime = '';

            if (metric.NumericType === NumericType.Time &&
                metric.TimeType === TimeType.Time) {
                const absoluteDiff = Math.abs(difference);
                formattedTime = this.getFormattedData(absoluteDiff, conversionType);
            }

            formattedValue = this.getFormattedData(Math.abs(difference), conversionType);

            return {
                ...metric,
                AverageValue: metric.FormattedCurrentAverage,
                PreviousAverage: metric.FormattedPreviousAverage,
                Difference: metric.NumericType === NumericType.Time && metric.TimeType === TimeType.Time
                    ? `${sign}${formattedTime}`
                    : `${sign}${formattedValue}`,
                Direction: directionText
            };
        });
    }

    updateMetricValueAverage() {
        this.metricResults.forEach(metric => {
            const current = this.currentMetricResults.find(c => c.MetricName === metric.MetricName);
            const previous = this.previousMetricResults.find(p => p.MetricName === metric.MetricName);
            const average = this.allMetrics.find(p => p.MetricDetail.Abbrev === metric.MetricName)

            // Update formatted average values
            if (average?.FormattedCurrentAverage) {
                metric.FormattedCurrentAverage = average.FormattedCurrentAverage;
                metric.AverageValue = average.CurrentAverage;
            }
            if (average?.FormattedPreviousAverage) {
                metric.FormattedPreviousAverage = average.FormattedPreviousAverage;
                metric.PreviousAverage = average.PreviousAverage;
            }

            // Updating IntervalAverages
            current?.IntervalAverages?.forEach(currAvg => {
                const target = metric.IntervalAverages.find(m => m.Date === currAvg.Date);
                if (target) {
                    target.FormattedValue = currAvg.FormattedValue;
                    target.AverageValue = currAvg.AverageValue;
                }
            });

            previous?.IntervalAverages?.forEach(prevAvg => {
                const target = metric.IntervalAverages.find(m => m.Date === prevAvg.Date);
                if (target) {
                    target.FormattedValue = prevAvg.FormattedValue;
                    target.AverageValue = prevAvg.AverageValue;
                }
            });
        });
    }

    async setDataForexportGHR() {
        // Creating a unique key based on ruleID and intervalSelected
        const cacheKey = this.getCacheKey(this.selectedGame.RuleID, this.gs.selectedInterval[0]?.DisplayStringDate);

        // Check if data is cached
        if (this.cache.has(cacheKey)) {
            // If the data is already cached, return the cached data
            return this.cache.get(cacheKey);
        }

        // If they are not cached, make the requests
        const [gameEffectiveness, topPerformers] = await Promise.all([
            this.getAllGameEffectivenessData(),
            this.getAllTopPerformers()
        ]);

        const exportData = this.createExportData(gameEffectiveness, topPerformers);
        this.cache.set(cacheKey, exportData);

        return exportData;
    }

    private getCacheKey(ruleID: number, selectedInterval: any): string {
        return `${ruleID}-${selectedInterval}`;
    }

    private createExportData(gameEffectiveness: any, topPerformers: any) {
        let Frequency = null;
        if (this.historyGame) {
            switch (this.historyGame.IntervalType) {
                case 0:
                    Frequency = this.getLocalizedText('Daily', 'Daily');
                    break;
                case 1:
                    Frequency = this.getLocalizedText('Weekly', 'Weekly');
                    break;
                case 2:
                    Frequency = this.getLocalizedText('Monthly', 'Monthly');
                    break;
                default:
                    break;
            }
        }

        if (this.selectedGame.GameType === this.GameTypeEnum.Brackets) {
            Frequency = this.getLocalizedText('N_A', 'N/A');
        }

        // Setting game details info
        let Participation = this.joinedCount + "/" + this.sumPlayers + " " + this.participantsPercentage + "%";
        let RewardsCollected = this.historyGame.CollectButton
            ? this.collectedCount + "/" + this.countParticipantRewards + " " + this.collectedRewardsPercentage + "%"
            : this.getLocalizedText('Collect_Button_Disabled', 'Collect Button disabled');
        let PercentageBudget = this.percentageBudget + "% " + this.getLocalizedText('Of_Total_Coins_Budget', 'of total coins budget');
        let Metric = this.gameMetric?.MetricDetail?.Name + " " + this.getLocalizedText('Avg', 'Avg') + " " + this.gameMetric.FormattedCurrentAverage
            + (this.selectedGame.GameType == this.GameTypeEnum.Connect3 || this.selectedGame.GameType == this.GameTypeEnum.Blackout ? ' +' + (this.selectedGame.SelectedMetrics.length - 1) + this.getLocalizedText('Metrics', 'Metrics') : '');
        let Qualifier = this.qualifier != undefined ? this.getLocalizedText('Avg', 'Avg') + " " + this.qualifier.FormattedCurrentAverage : this.getLocalizedText('None', 'None');

        const connect3Definitions = this.historyGame?.Connect3Definition ? {
            Connect3Definition: this.historyGame.Connect3Definition.filter(definition => definition.MetricID > 0), // remove free space
        }: {};

        const customGameExportData = this.historyGame ? {
            MetricDefinition: this.historyGame.metricDefinition,
            ...connect3Definitions,
        } : {};

        if (gameEffectiveness !== undefined && gameEffectiveness !== null) {
            this.exportData = {
                ghObjects: this.participants,
                game: {
                    ...this.selectedGame,
                    ...customGameExportData,
                    GameDetails: {
                        Frequency,
                        Participation,
                        RewardsCollected,
                        PercentageBudget,
                        TotalCoins: this.sumCoins,
                        TotalXP: this.sumXP,
                        TotalBadges: this.sumBadges,
                        GamePeriod: this.GameEffectiveness.gamePeriod,
                        PreviousPeriod: this.GameEffectiveness.previousPeriod,
                        Metric,
                        Qualifier
                    }
                },
                gameEffectivenessData: gameEffectiveness,
                topPerformersData: topPerformers,
            };
        }
        return this.exportData;
    }

    checkTextTruncation(tooltip: string, type: string): string {
        switch (type) {
            case "Rewards_Collected":
                if (this.rewards_collected) {
                    return this.rewards_collected.nativeElement.scrollWidth !== this.rewards_collected.nativeElement.clientWidth ? tooltip : "";
                }
                break;
            case "Collect_Button":
                if (this.collect_button) {
                    return this.collect_button.nativeElement.scrollWidth !== this.collect_button.nativeElement.clientWidth ? tooltip : "";
                }
                break;
        }
        return "";
    }

    async CalculateAverageInterval() {
        this.getMetrics();
        if (this.participants && this.GameEffectiveness) {
            const cacheKey = this.getAverageValuesCacheKey(
                this.selectedGame.RuleID,
                this.gs.selectedInterval[0]?.DisplayStringDate
            );

            if (this.averageValuesCache.has(cacheKey)) {
                const cached = this.averageValuesCache.get(cacheKey)!;
                this.previousMetricResults = cached.previous;
                this.currentMetricResults = cached.current;
                return;
            }

            const formattedParticipants = this.participants.map(({ participant }) => ({
                ...participant,
                GroupID: participant.RelatedGroupID
            })) || [];

            const startDate = new Date(this.intervalSelected[0].StartDate);
            let endDate: string;
            const previousPeriodDatesArray = this.GameEffectiveness.getPreviousPeriod().split(' - ');
            const previousStart = new Date(previousPeriodDatesArray[0]);
            const previousDate = startDate.toISOString().replace(/\.\d{3}Z$/, '');

            let previousEnd: string;

            if (this.selectedGame.IntervalType === "Day") {
                endDate = previousDate;
                previousEnd = previousStart.toISOString().replace(/\.\d{3}Z$/, '');
            } else {
                const adjustedEndDate = new Date(this.intervalSelected[0].EndDate);
                adjustedEndDate.setDate(adjustedEndDate.getDate() - 1);
                endDate = adjustedEndDate.toISOString().replace(/\.\d{3}Z$/, '');
                const adjustedPreviousEnd = new Date(previousPeriodDatesArray[1]);
                previousEnd = adjustedPreviousEnd.toISOString().replace(/\.\d{3}Z$/, '');
            }

            const intervals = [
                { start: previousStart.toISOString().replace(/\.\d{3}Z$/, ''), end: previousEnd },
                { start: previousDate, end: endDate }
            ];

            const combinedMetrics = this.metricList.length
                ? [...this.metricList, ...(this.qualifier ? [this.qualifier] : [])]
                : [this.gameMetric, ...(this.qualifier ? [this.qualifier] : [])];

            if (combinedMetrics[0] != null) {
                const [previousMetrics, currentMetrics] = await Promise.all(
                    intervals.map(({ start, end }) =>
                        Promise.all(
                            combinedMetrics.filter(m => m.MetricID > 0).map(metric => // filter out free space metrics
                                this.gamesService.LoadMetricRanking(
                                    metric.MetricID.toString(),
                                    formattedParticipants,
                                    start,
                                    end,
                                    true,
                                    this.selectedGame.RuleID
                                )
                            )
                        )
                    )
                );

                this.previousMetricResults = previousMetrics;
                this.currentMetricResults = currentMetrics;

                const getAverages = (metricsArray) => {
                    metricsArray.forEach(item => {
                        const averages = item.IntervalAverages || [];
                        const total = averages.reduce((sum, curr) => sum + (curr.AverageValue ?? 0), 0);
                        const length = averages.length;
                        item.averageValue = length > 0 ? total / length : 0;
                    });
                };

                getAverages(this.previousMetricResults);
                getAverages(this.currentMetricResults);

                this.averageValuesCache.set(cacheKey, {
                    previous: this.previousMetricResults,
                    current: this.currentMetricResults
                });
            }
        }
    }

    private getAverageValuesCacheKey(ruleId: number, displayInterval: string): string {
        return `AverageValuesCache_${ruleId}_${displayInterval}`;
    }
}
